import { render } from "./Section2View.vue?vue&type=template&id=60f17b85&scoped=true"
import script from "./Section2View.vue?vue&type=script&lang=js"
export * from "./Section2View.vue?vue&type=script&lang=js"

import "./Section2View.vue?vue&type=style&index=0&id=60f17b85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f17b85"]])

export default __exports__